/**
 * @file 临时数据 读写
 * @author svon.me@gmail.com
 **/

import type {Storage} from "./data";

export const remove = function (key: string): void {
  sessionStorage.removeItem(key);
}

export const clear = function () {
  sessionStorage.clear();
}

export const set = function (key: string, data: any): void {
  const tmp: Storage = {v: data};
  const text: string = JSON.stringify(tmp);
  sessionStorage.setItem(key, text);
}

export const get = function (key: string): any | undefined {
  let data: Storage;
  const text: string = sessionStorage.getItem(key);
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
    }
  }
  return data ? data.v : void 0;
}